export default __webpack_public_path__ + "static/media/WebResume1.af16407d.png";